module.exports = __webpack_public_path__ + "static/assets/d5f612fcbc4be45012074bc10ccd52d1.png";